import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { CompositeLayer } from '@deck.gl/core';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import { load } from '@loaders.gl/core';
import GL from '@luma.gl/constants';
import SphericalMercator from '@mapbox/sphericalmercator';
import { omit as _omit } from 'lodash';
var DEFAULT_TILE_SIZE = 256;
var WmsLayer = /*#__PURE__*/function (_CompositeLayer) {
  _inherits(WmsLayer, _CompositeLayer);
  var _super = _createSuper(WmsLayer);
  function WmsLayer(props) {
    var _this;
    _classCallCheck(this, WmsLayer);
    _this = _super.call(this, _omit(props, ['onClick', 'onHover']));
    _this.originProps = props;
    return _this;
  }
  _createClass(WmsLayer, [{
    key: "onClick",
    value: function onClick(event, info) {
      if (typeof this.originProps.onClick === 'function') {
        this.originProps.onClick(this.props.key, event, info);
      }
    }
  }, {
    key: "renderLayers",
    value: function renderLayers() {
      return [this.renderWmsLayer()];
    }
  }, {
    key: "getPickable",
    value: function getPickable() {
      var options = this.props.options;
      var pickable = options.pickable === true || false;
      return pickable;
    }
  }, {
    key: "renderWmsLayer",
    value: function renderWmsLayer() {
      var _ref,
        _this2 = this;
      var _this$props = this.props,
        options = _this$props.options,
        opacity = _this$props.opacity,
        key = _this$props.key;
      if (!options) {
        throw new Error('WmsLayer: options are not defined!');
      }
      var url = options.url,
        params = options.params,
        _options$transparentC = options.transparentColor,
        transparentColor = _options$transparentC === void 0 ? [0, 0, 0, 0] : _options$transparentC,
        _options$textureParam = options.textureParameters,
        textureParameters = _options$textureParam === void 0 ? (_ref = {}, _defineProperty(_ref, GL.TEXTURE_MIN_FILTER, GL.LINEAR_MIPMAP_LINEAR), _defineProperty(_ref, GL.TEXTURE_MAG_FILTER, GL.LINEAR), _defineProperty(_ref, GL.TEXTURE_WRAP_S, GL.CLAMP_TO_EDGE), _defineProperty(_ref, GL.TEXTURE_WRAP_T, GL.CLAMP_TO_EDGE), _ref) : _options$textureParam;
      if (!url) {
        throw new Error('WmsLayer: options.url is not defined!');
      }
      if (!params) {
        throw new Error('WmsLayer: options.params are not defined!');
      }
      var layers = params.layers,
        format = params.format,
        styles = params.styles,
        version = params.version;
      if (!layers) {
        throw new Error('WmsLayer: options.params.layers are not defined!');
      }
      var id = "".concat(key, "-wmsLayer-").concat(url);
      var tileSize = params.tileSize || DEFAULT_TILE_SIZE;
      var conversion = new SphericalMercator({
        size: tileSize,
        antimeridian: true
      });
      var pickable = this.getPickable();
      return new TileLayer({
        id: id,
        opacity: opacity,
        tileSize: tileSize,
        pickable: pickable,
        transparentColor: transparentColor,
        getTileData: function getTileData(tile) {
          var x = tile.x,
            y = tile.y,
            z = tile.z,
            index = tile.index;
          x = x || index.x;
          y = y || index.y;
          z = z || index.z;
          // Conversion needed due to visualizations issues.
          var _conversion$bbox = conversion.bbox(x, y, z, false, '900913'),
            _conversion$bbox2 = _slicedToArray(_conversion$bbox, 4),
            west = _conversion$bbox2[0],
            south = _conversion$bbox2[1],
            east = _conversion$bbox2[2],
            north = _conversion$bbox2[3];
          var urlQueryStringParams = {
            bbox: [west, south, east, north].join(','),
            format: format || 'image/png',
            height: tileSize,
            layers: layers,
            request: 'GetMap',
            service: 'WMS',
            styles: styles || '',
            width: tileSize,
            transparent: true
          };
          if (Object.hasOwn(params, 'transparent')) {
            urlQueryStringParams.transparent = params.transparent;
          }
          if (version === '1.1.1') {
            urlQueryStringParams.srs = 'EPSG:3857';
            urlQueryStringParams.version = '1.1.1';
          } else {
            urlQueryStringParams.crs = 'EPSG:3857';
            urlQueryStringParams.version = '1.3.0';
          }
          var urlQueryString = Object.keys(urlQueryStringParams).map(function (key) {
            return "".concat(key, "=").concat(urlQueryStringParams[key]);
          }).join('&');
          var finalUrl = url + '?' + urlQueryString;
          return load(finalUrl);
        },
        renderSubLayers: function renderSubLayers(props) {
          var _props$tile$bbox = props.tile.bbox,
            west = _props$tile$bbox.west,
            south = _props$tile$bbox.south,
            east = _props$tile$bbox.east,
            north = _props$tile$bbox.north;
          var pickable = _this2.getPickable();
          return new BitmapLayer(_objectSpread(_objectSpread({}, props), {}, {
            pickable: pickable,
            data: null,
            image: props.data,
            bounds: [west, south, east, north],
            textureParameters: textureParameters
          }));
        }
      });
    }
  }]);
  return WmsLayer;
}(CompositeLayer);
export default WmsLayer;